import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPayout from './payout.reducer';
import { PayoutState } from './payout.reducer';

export const selectPayoutState = createFeatureSelector<fromPayout.PayoutState>(
  fromPayout.payoutFeatureKey
);

export const selectPayouts = createSelector(
  selectPayoutState,
  state => state.payouts
);

export const selectPayoutById = (id: string) =>
  createSelector(
    selectPayoutState,
    (state: PayoutState): PayoutState => ({
      ...state,
      payout: state.payouts.find(payout => payout.id === id) ?? null,
    })
  );

export const selectSelectedPayout = createSelector(
  selectPayoutState,
  state => state.payout
);
